import React from "react";
import { MainDiv } from "../components/Profile/Profile.style";
import ProfilePart from "../components/ProfilePart/ProfilePart";

const ProfilePage = () => {
  return (
    <MainDiv
      style={{
        height: "calc(100vh - 70px)",
      }}
    >
      <ProfilePart></ProfilePart>
    </MainDiv>
  );
};

export default ProfilePage;
